import ModalBase, { IModalBaseProps, ModalBaseRefType } from "@/Components/Base/ModalBase";
import FaturaDuplicarFormBasic, { FaturaDublicarFormType } from "./FaturaDuplicarForm";
import { Form } from "antd";
import { useRef, useState } from "react";

export interface IFaturaDupliucarFormModalProps extends IModalBaseProps {
    codFatura:number;
    onSuccess?:() => void;
}

export default function FaturaDupliucarFormModal ({
    codFatura,
    textButtonOpen,
    width,
    propsButtonOpen,
    okText,
    destroyOnClose,
    onSuccess,
    ...props
}:IFaturaDupliucarFormModalProps) {
    propsButtonOpen = propsButtonOpen ?? {};
    propsButtonOpen.style = propsButtonOpen.style ?? {};

    const refModal = useRef<ModalBaseRefType|null>(null);
    const [ form ] = Form.useForm<FaturaDublicarFormType>();
    const [carregando, setCarregando] = useState(false);

    return <ModalBase
        {...props}
        ref={refModal}
        title={textButtonOpen ?? "Duplicar"}
        width={width ?? "85vw"}
        destroyOnClose={destroyOnClose ?? true}
        textButtonOpen={textButtonOpen ?? "Dup."}
        propsButtonOpen={{
            ...propsButtonOpen,
            type : propsButtonOpen.type ?? "dashed",
            size : propsButtonOpen.size ?? "small",
            style : {
                ...propsButtonOpen.style,
                width : propsButtonOpen.style.width ?? "min-content"
            }
        }}
        onOk={() => {
            setCarregando(true);
            form.submit();
        }}
        okText={okText ?? "Duplicar"}
        confirmLoading={carregando}
    >
        <FaturaDuplicarFormBasic 
            codFatura={codFatura}
            form={form} 
            onSuccess={() => {
                refModal.current?.fechar();
                onSuccess?.();
            }}
            onFinish={(_, __, ___, ____) => {
                setCarregando(false);
            }}
        />
    </ModalBase>; 
}